<script>
export default {
  name: "customerPortal",
  data() {
    return {
      enabled: false,
      portalUrl: "",
      defaultProofEmailTemplateId: null,
      defaultNewVersionEmailTemplateId: null,
      working: false,
    };
  },
  async mounted() {
    // Fetch fresh: sessions created before this feature deployed lack the new
    // account fields, and the portal URL is computed server-side (single source
    // of truth with the magic-link email's app URL).
    const account = await this.$A.AccountService.Get();
    this.enabled = _.get(account, "customerPortalEnabled", false);
    this.portalUrl = _.get(account, "portalUrl", "") || "";
    this.defaultProofEmailTemplateId = _.get(account, "defaultProofEmailTemplateId", null);
    this.defaultNewVersionEmailTemplateId = _.get(account, "defaultNewVersionEmailTemplateId", null);
  },
  methods: {
    async toggleChanged() {
      if (this.working) return;
      this.working = true;
      const account = await this.$A.AccountService.SetCustomerPortalEnabled(
        this.enabled,
        this.defaultProofEmailTemplateId,
        this.defaultNewVersionEmailTemplateId
      );
      this.working = false;
      if (account) {
        this.enabled = _.get(account, "customerPortalEnabled", this.enabled);
        this.portalUrl = _.get(account, "portalUrl", "") || "";
        _.set(this.$A, "Auth.account.customerPortalEnabled", this.enabled);
        this.$A.SaveSessionData(this.$A.Auth);
      }
    },
    copyUrl() {
      this.$A.CopyStringToClipboard(this.portalUrl);
      this.$A.AlertUser("Portal Link Copied", "success", 5000);
    },
  },
};
</script>

<template>
  <div class="settings-card">
    <div class="card-head">
      <div class="card-head-title">Contact Portal</div>
      <div class="card-head-subtitle">
        Give your contacts one place to sign in and see all of their proofs.
        They sign in with just their email — no passwords.
      </div>
    </div>
    <div class="card-body">
      <div class="ashore-toggle portal-toggle-row">
        <label class="switch">
          <input type="checkbox" v-model="enabled" @change="toggleChanged" />
          <span class="slider round"></span>
        </label>
        Enable the contact portal
      </div>

      <div v-if="enabled && portalUrl" class="field portal-url-field">
        <label class="field-label">Your Portal Link</label>
        <b-input-group>
          <b-form-input class="portal-url-input" :value="portalUrl" readonly></b-form-input>
          <b-input-group-append>
            <b-button
              variant="copy-link"
              v-b-tooltip.click
              title="Copied to Clipboard!"
              @click="copyUrl"
              >Copy</b-button
            >
          </b-input-group-append>
        </b-input-group>
        <small class="portal-url-hint">
          Share this link with your contacts, or let them discover the portal
          after they approve a proof.
        </small>
      </div>
    </div>
  </div>
</template>

<style scoped>
.settings-card {
  background: #fff;
  border: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(8, 11, 13, 0.04), 0 8px 24px -16px rgba(8, 11, 13, 0.1);
}
.card-head {
  padding: 14px 20px;
  background: #fbfbfc;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 12px 12px 0 0;
}
.card-head-title {
  font-weight: 600;
  color: #111827;
}
.card-head-subtitle {
  font-size: 13px;
  color: #6b7280;
}
.card-body {
  padding: 20px;
}
.portal-toggle-row {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: #374151;
}
.portal-url-field {
  margin-top: 18px;
}
.field-label {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
}
.portal-url-input {
  font-size: 13px;
  color: #4b5563;
  background: #f9fafb;
}
.btn-copy-link {
  color: #ffffff;
  padding: 0 25px;
  background-color: #019255;
  border-color: #019255;
}
.btn-copy-link:hover {
  color: #ffffff !important;
  background-color: #0c390e;
  transition: all 0.5s ease;
}
.portal-url-hint {
  color: #9ca3af;
}
</style>
